import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatosService } from 'src/app/services/platos.service';
import { GLOBAL } from 'src/app/services/global';
import { FollowService } from 'src/app/services/follow.service';
import { MetricaService } from 'src/app/services/metrica.service';
import { RestauranteService } from 'src/app/services/restaurante.service';

@Component({
  selector: 'app-pagina-establecimiento',
  templateUrl: './pagina-establecimiento.component.html',
  styleUrls: ['./pagina-establecimiento.component.css']
})
export class PaginaEstablecimientoComponent implements OnInit {

  tipo: string;
  slug: string;
  pantallaCargada: boolean = false;
  url: string;
  seccion: string;
  plato: any;
  establecimiento: any;
  userLogin: any;
  follow: boolean;
  follows: number;
  visualizaciones: number;
  pos: any = null;

  @ViewChild("btnLike", null) btnLike: { nativeElement: any; }

  constructor(private route: ActivatedRoute,
    private pService: PlatosService,
    private fService: FollowService,
    private router: Router,
    private mService: MetricaService,
    private rService: RestauranteService,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.url = GLOBAL.url;

    this.route.params.subscribe(result => {
      this.tipo = this.route.snapshot.data['tipo'];
      this.seccion = this.route.snapshot.data['seccion'];
      this.slug = result.slug;

      if(this.tipo == 'plato'){
        this.seccion = 'plato';
        this.getInfoPlato(this.slug);
      }
      if(this.tipo == 'establecimiento'){
        this.getInfoEstablecimiento(this.slug);
      }
    });
  }

  getInfoPlato(slug: string) {
    this.pService.getInfoPlatoBySlug(slug).subscribe(result => {
      this.plato = result;
      this.establecimiento = result.restaurante;
      this.visualizaciones = result.visualizaciones;
      this.getTotalSeguidores();
      this.getFollow();
      this.pantallaCargada = true;
      this.route.queryParamMap.subscribe((params) => {
        if (params.get('nombreMarca') == null || params.get('nombreMarca') == "") {
          this.addMetrica(1);
        }
      });
    });
  }

  getInfoEstablecimiento(slug: string) {
    this.rService.getInfoRestauranteBySlug(slug).subscribe(result => {
      console.log("result", result);
      this.establecimiento = result;
      this.visualizaciones = result.visualizaciones;
      this.getTotalSeguidores();
      this.getFollow();
      this.pantallaCargada = true;
      if(this.seccion == 'info'){
        this.addMetrica('visualizacionInformacion');
      }else if(this.seccion == 'carta'){
        this.route.queryParamMap.subscribe((params) => {
          if (params.get('nombreMarca') == null || params.get('nombreMarca') == "") {
            this.addMetrica('visualizacionCarta');
          }
        });
      }
    });
  }

  onClickSelectSeccion(seccion: string){
    window.scrollTo(0, 0);
    this.seccion = seccion;

    if(this.seccion == 'info'){
      this.tipo = 'establecimiento';
      this.addMetrica('visualizacionInformacion');
    }

    if(this.seccion == 'carta'){
      this.tipo = 'establecimiento';
      this.route.queryParamMap.subscribe((params) => {
        if (params.get('nombreMarca') == null || params.get('nombreMarca') == "") {
          this.addMetrica('visualizacionCarta');
          console.log('visualizacionCarta');
        }
      });
    }

    if(this.seccion == 'plato'){
      this.tipo = 'plato';
      this.route.queryParamMap.subscribe((params) => {
        if (params.get('nombreMarca') == null || params.get('nombreMarca') == "") {
          this.addMetrica(1);
        }
      });
      
    }

  }

  onIrAPlato(plato: any): void {
    this.plato = plato;
    this.seccion = 'plato';
  }

  onClickLike() {
    if (this.userLogin == null) {
      this.router.navigate(['registrarse'], { queryParams: { marcaFicha: this.plato.nombre_plato } });
    } else {
      if(this.tipo == 'plato'){
        this.fService.setSeguidorPlato(this.plato.id, this.userLogin.id).subscribe(result => {
          let resultInsertFollow = result;

          if (resultInsertFollow.result == "ok") {
            this.follow = true;
            $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Artículo guardado');
            $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
          }

          if (resultInsertFollow.result == "delete") {
            this.follow = false;
            $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Guardar artículo');
            $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
          }

          this.getTotalSeguidores();
        });
      } else {
        this.fService.setSeguidorRestaurante(this.establecimiento.id, this.userLogin.id).subscribe(result => {
          let resultInsertFollow = result;

          if (resultInsertFollow.result == "ok") {
            this.follow = true;
            if(this.seccion == 'carta'){
              $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Carta guardada');
              $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
            } 
          } else if (resultInsertFollow.result == "delete") {
            this.follow = false;
            if(this.seccion == 'carta'){
              $(this.btnLike.nativeElement).html('<i class="fa fa-bookmark" aria-hidden="true"></i> Guardar carta');
              $(this.btnLike.nativeElement).children('.fa-bookmark').addClass('animate-like');
            }
          }

          this.getTotalSeguidores();
        });
      }
    }

  }

  getTotalSeguidores = () => {

    if(this.tipo == 'plato'){
      this.fService.getTotalSeguidoresPlatos(this.plato.slug).subscribe(result2 => {
        this.follows = result2;
      });
    } else {
      this.fService.getTotalSeguidoresRestaurante(this.establecimiento.id).subscribe(result2 => {
        this.follows = result2;
      });
    }
  }

  getFollow(){
    if(this.userLogin != null){
      if(this.tipo == 'plato'){
        this.fService.comprobarFollowPlato(this.plato.id, this.userLogin.id).subscribe(resultado => {
          if (resultado.result == 'si') {
            this.follow = true;
          }
          if (resultado.result == 'no') {
            this.follow = false;
          }
        });
      } else {
        this.fService.comprobarFollowRest(this.establecimiento.id, this.userLogin.id).subscribe(resultado => {
          if (resultado.result == 'si') {
            this.follow = true;
          }
          if (resultado.result == 'no') {
            this.follow = false;
          }
        });
      }
    } else {
      this.follow = false;
    }
  }

  clickIrA() {
    if (this.pos == null) {
      this.pantallaCargada = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          const url = `https://www.google.com/maps/dir/?api=1&origin=${this.pos.lat},${this.pos.lng}&destination=${this.establecimiento.lat},${this.establecimiento.lng}&travelmode=walking`;
          window.open(url, '_blank');
          this.addMetrica('clickIrA');
          this.pantallaCargada = false;
        }, (error) => {
          this.pantallaCargada = false;
        });
      }
    }
  }

  addMetrica(tipo_interaccion) {

    let plato_id = null;

    if(this.tipo == 'establecimiento'){
      if(tipo_interaccion == 'visualizacionCarta'){
        tipo_interaccion = 5;
      } else if(tipo_interaccion == 'visualizacionInformacion'){
        tipo_interaccion = 6;
      } else if(tipo_interaccion == 'clickReserva'){
        tipo_interaccion = 7;
      } else if(tipo_interaccion == 'clickPedidos'){
        tipo_interaccion = 8;
      } else if(tipo_interaccion == 'clickIrA'){
        tipo_interaccion = 10;
      }
    }

    if(this.tipo == 'plato'){
      plato_id = this.plato.id;
    }

    let modeloMetrica = {
      establecimiento_id: this.establecimiento.id,
      articulo_id: plato_id,
      tipo_interaccion: tipo_interaccion
    }

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Metrica guardada");
      } else {
        console.log("Error a la hora de guardar en metrica");
      }
    });

  }

  clickReservas() {
    this.addMetrica("clickReserva");
    const url = this.establecimiento.enlace_menu_del_dia;
    window.open(url, '_blank');
  }

  clickPedidos() {
    this.addMetrica("clickPedidos");
    const url = this.establecimiento.take_away_link;
    window.open(url, '_blank');
  }

}
